import React from 'react';
import * as S from './ErrorBoundary.styled';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
    this.setState({ errorInfo });
    
    if (import.meta.env.PROD) {
      fetch('/api/log-error', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ error: error.toString(), stack: error.stack })
      }).catch(e => console.error(e));
    }
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
    window.location.href = '/';
  };

  render() {
    if (this.state.hasError) {
      return (
        <S.ErrorContainer>
          <S.ErrorIcon>⚠️</S.ErrorIcon>
          <S.ErrorTitle>Что-то пошло не так</S.ErrorTitle>
          <S.ErrorMessage>
            Произошла ошибка при загрузке страницы. Пожалуйста, попробуйте обновить страницу.
          </S.ErrorMessage>
          {import.meta.env.DEV && this.state.error && (
            <S.ErrorDetails>
              <strong>{this.state.error.toString()}</strong>
              <pre>{this.state.errorInfo?.componentStack}</pre>
            </S.ErrorDetails>
          )}
          <S.ErrorButton onClick={this.handleReset}>
            На главную
          </S.ErrorButton>
        </S.ErrorContainer>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;